import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage as fallback (also cookie is set httpOnly)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cq_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STATUSES = [
  "Getting Started",
  "Credit Analysis",
  "Disputes Submitted",
  "Bureau Processing",
  "Results Coming In",
  "Credit Optimization",
  "Funding Ready",
  "Funding in Progress",
  "Completed",
];

export const DUCK_LOGO =
  "https://customer-assets.emergentagent.com/job_quack-dashboard-pro/artifacts/1d0pp3z8_7_6_2024%2C%2012_21_00%20AM%20-%20Edited%20%281%29.png";
